import { memo, useMemo } from "react";

const RequestFormInput = ({
    label,
    type = "text",
    value = '',
    onChange = null,
    errorMessage,
    maxLength,
    id,
    placeholder,
    onClick,
    readOnly = false,
    isdisabled = false,
    required,
    togglePasswordVisibility,
    isShowError = true,
    isDate = false,
    width = '100%'
}) => {

    const renderedLabel = useMemo(() => {
        return label?.trim()?.length > 0 ? (
            <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible"
                htmlFor={id} style={{ display: label === "Invite Mobile Number" && 'none' }}>
                {label} {required && <span className="mandatory">*</span>}
            </label>
        ) : null;
    }, [label, required, id]);

    const inputField = useMemo(() => {
        return (
            <>
                <div className="position-relative">
                    <input
                        type={(typeof value === 'string' && value?.trim().length > 0) ? type : 'text'}
                        id={id}
                        className={`form-control mb-5px RequestFormInput ${isDate ? "RequestFormDateClass" : ""} ${isdisabled ? "nocursor" : ""} `}
                        value={value}
                        placeholder={placeholder}
                        maxLength={maxLength}
                        onChange={onChange}
                        onClick={onClick}
                        autoComplete="off"
                        inputMode="none"
                        onFocus={e => e.target.blur()}
                        disabled={isdisabled}
                        style={{ maxWidth: width, borderColor: errorMessage ? "#c8605e" : "" }}
                    />
                    {togglePasswordVisibility && <button
                        type="button"
                        className="btn btn-light position-absolute end-0 top-50 translate-middle-y p-0 border-0 bg-transparent  me-3"
                        onClick={togglePasswordVisibility}
                        aria-label="Toggle password visibility"
                        style={{ zIndex: 10 }}
                    >
                        <i
                            className={`fas ${type == 'password' ? "fa-eye" : "fa-eye-slash"
                                } text-dark font-size-12`}
                        ></i>
                    </button>}
                </div>
                {(errorMessage && isShowError) && <div className="text-danger-new fw-700 fs-6 mt-1">{errorMessage}</div>}
            </>
        );
    }, [type, id, value, placeholder, maxLength, onChange, onClick, errorMessage, isdisabled]);

    return (
        <div className={placeholder == 'Subject' ? '' : ""}>
            {renderedLabel}
            {inputField}
        </div>
    );
};

export default memo(RequestFormInput);
